import { rawInitData } from "./telegram";

const BASE = "/api";

export class ApiError extends Error {
  constructor(
    public status: number,
    message: string,
    public body?: unknown,
  ) {
    super(message);
  }
}

export async function api<T>(
  method: "GET" | "POST" | "PATCH",
  path: string,
  opts?: { json?: unknown; form?: FormData; signal?: AbortSignal },
): Promise<T> {
  const headers: HeadersInit = { Authorization: `tma ${rawInitData}` };
  let body: BodyInit | undefined;
  if (opts?.json !== undefined) {
    headers["Content-Type"] = "application/json";
    body = JSON.stringify(opts.json);
  } else if (opts?.form !== undefined) {
    body = opts.form;
  }
  const res = await fetch(`${BASE}${path}`, {
    method,
    headers,
    body,
    signal: opts?.signal,
  });
  const text = await res.text();
  const payload = text ? JSON.parse(text) : null;
  if (!res.ok)
    throw new ApiError(
      res.status,
      (payload as { detail?: string } | null)?.detail ?? res.statusText,
      payload,
    );
  return payload as T;
}

export async function apiBlob(path: string): Promise<Blob> {
  const res = await fetch(`${BASE}${path}`, {
    headers: { Authorization: `tma ${rawInitData}` },
  });
  if (!res.ok) {
    const text = await res.text();
    const payload = text ? (JSON.parse(text) as { detail?: string } | null) : null;
    throw new ApiError(res.status, payload?.detail ?? res.statusText, payload);
  }
  return res.blob();
}

export async function patchChatCurrency(chatId: number, currency: string): Promise<void> {
  await api("PATCH", `/chats/${chatId}`, { json: { currency } });
}

export async function setClaimPortion(
  chatId: number,
  receiptId: string,
  itemIdx: number,
  portion: number | null,
): Promise<void> {
  await api(
    "PATCH",
    `/chats/${chatId}/receipts/${receiptId}/items/${itemIdx}/claims/portion`,
    { json: { portion } },
  );
}
